import api from '../api'
import { axios as $http } from 'cm'
import { throttle } from '../../../../public-resource/libs/utils/index'
import Bridge from '../../../../frontend-lib/lib/Bridge'

let IS_APP = window.$platform.isYixinliApp
let myBridge = new Bridge()

class SpecialList {
  constructor() {
    this.loading = false
    this.page = 1
    this.hasShowAll = false

    this.getListData()
    this.bindEvent()
  }
  getListData() {
    if (this.loading || this.hasShowAll) return
    this.loading = true
    $('.loading-more').show()

    let params = {
      page: this.page,
      size: 10
    }

    $http
      .get(api.getActivityRecommend, {
        params
      })
      .then(res => {
        res = res.data
        this.loading = false
        $('.loading-more').hide()
        if (+res.code === 0) {
          this.page++

          if (!res.data.length) {
            this.hasShowAll = true
          } else {
            this.renderList(res.data)
          }
        } else {
          window.toast(res.message)
        }
      })
      .catch(() => {
        this.loading = false
        $('.loading-more').hide()
      })
  }
  renderList(specialList) {
    let list = ''
    specialList.forEach(item => {
      list += `
        <li activityId=${item.id}>
          <img src="${item.search_img}?x-oss-process=image/resize,p_60/quality,Q_80">
          <div>${item.name}</div>
        </li>
      `
    })
    $('.specialsWrap ul').append(list)
  }
  bindEvent() {
    let that = this

    $(document).delegate('.specialsWrap li', 'click', function(e) {
      let url = `${api.host}/activity/${$(this).attr('activityId')}`
      if (IS_APP) {
        myBridge.call('openWebView', {
          url,
          isCurrentPageOpen: 0
        })
      } else {
        window.open(url)
      }
    })

    let scroll = throttle(function() {
      // console.log($(this).innerHeight(), $(this).scrollTop(), this.scrollHeight)
      let height = $(this).innerHeight()
      let scrollHeight = this.scrollHeight
      let scrollTop = $(this).scrollTop()
      if (scrollTop > 0 && height + scrollTop > scrollHeight - 20) {
        that.getListData()
      }
    }, 500)
    $('.specialsWrap').on('scroll', scroll)
  }
}

module.exports = SpecialList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/specialList.js